import Bluebird from 'bluebird';
import { deferTask } from '../../../../services/defer-task';
import { strEndsWith } from '../../../../services/strings';
import { isExternal, isTest } from '../../services/app-storage';
import host from '../../services/current-host';
import { $id } from '../../services/jquery-utils';
import loadWidget from '../widget-core/_loader';

export function loadWidgetStandalone
    (options: {
        // Element to render the widget in
        id?: string,

        // From where to fetch widget script
        src?: string,

        currency?: string,
        language?: string,

        // Stay on the same page while booking
        useIframe?: boolean,

        iframeOptions?: {
            fullScreen?: boolean,
            noheader?: boolean
        }
    } = {}): Bluebird<void> {
    // Init default options
    const {
        id = 'gete-widget',
        currency = 'EUR',
        language = 'en',
        useIframe = false,
        iframeOptions = {
            fullScreen: false,
            noheader: false
        }
    } = options;

    let src = options.src || (isTest && !isExternal ? host : 'https://book.get-e.com');
    if (strEndsWith(src, '/')) {
        // Strip ending /
        src = src.substr(0, src.length - 1);
    }

    // Bind options to window so they can be accessed by the widget
    if (typeof window.GETE === 'undefined') window.GETE = {};

    window.GETE.widgetOptions = {
        useIframe, src, currency, language, iframeOptions: {
            id: 'gete-widget-frame',
            toggleClass: 'gete-widget-toggle',
            fullScreen: !!iframeOptions.fullScreen,
            noheader: !!iframeOptions.noheader,
        }
    };

    // Start loading scripts
    const $widget = $id(id);
    const widgetEmpty = () => !$widget.html().trim();

    if (!widgetEmpty()) {
        return loadWidget();
    }

    $widget.hide();

    return new Bluebird<any>((resolve, reject) => {
        const htmlURL = `${src}/${language}/widget`;

        $widget.load(htmlURL, () => {
            if (widgetEmpty()) {
                return reject(new Error(`Failed loading ${htmlURL}`));
            }

            loadWidget().then(() => deferTask(() => {
                if (document.documentElement.classList
                    .contains('gete-booking-in-progress')) {
                    return resolve();
                }

                $widget.fadeIn(100, () => {
                    resolve();
                });
            }), reject);
        });
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-bundle/widget-loader.ts